import classNames from 'classnames';

import { PaymentStatusEnum } from '../../../lib/enums/payments/payment-status.enum';
import lang from '../../../lib/language';
import { Payment } from '../../../lib/models/crm/types';
import { isWithdrawal } from '../../../lib/store/selectors';
import { formatTransaction } from '../../../lib/util/DataHelpers';
import { parseDateTo, ParseToType } from '../../../lib/util/DateTimeHelpers';
import { TextHelpers } from '../../../lib/util/TextHelpers';

import IconMinus from '../../../assets/img/wallet/icon-minus.svg';
import IconPlus from '../../../assets/img/wallet/icon-plus.svg';
import { useIsMobile } from '../../../hooks';

import styles from './Transactions.module.scss';

type Props = {
    payment: Payment
}

const TransactionItem = ({ payment }: Props) => {
  const { isMobile } = useIsMobile();
  const displayStatus = () => {
    if (payment.payment_status === PaymentStatusEnum.Completed) {
      return (
        <p className={styles.hidePendingText}>
          {TextHelpers.getPaymentStatusName(payment.payment_status)}
        </p>
      );
    }
    if (payment.payment_status === PaymentStatusEnum.Rejected
      || payment.payment_status === PaymentStatusEnum.Canceled) {
      return (
        <p className={styles.errorText}>
          {TextHelpers.getPaymentStatusName(payment.payment_status)}
        </p>
      );
    }
    if (payment.payment_status === PaymentStatusEnum.ForApproval) {
      return (
        <p className={styles.pendingText}>
          {lang.commonOrderStatusPendingApproval()}
        </p>
      );
    }
    return null;
  };

  return (
    <>
      { isMobile ? (
        <>
          <div className={styles.wrapperInfoMobile}>
            <div className={styles.iconWrapper}>
              <img
                className={styles.icon}
                src={
                  (payment.amount < 0 || isWithdrawal(payment))
                    ? IconMinus
                    : IconPlus
                  }
                alt="icon arrow"
              />
            </div>
            <div className={styles.infoWrapper}>
              <div className={styles.wrapperLine}>
                <div className={styles.paymentType}>
                  {TextHelpers.getPaymentProcessName(payment.payment_process)}
                </div>
                <div className={classNames(styles.paymentAmount,
                  { [styles.paymentAmountRejected]: payment.payment_status
                    === PaymentStatusEnum.Rejected })}
                >
                  {formatTransaction(payment, 'amount')}
                </div>
              </div>
              <div className={styles.wrapperLine}>
                <div className={styles.paymentDate}>
                  { `${parseDateTo(new Date(payment.create_date), ParseToType.displayFormat)}` }
                </div>
                <div className={styles.paymentStatus}>
                  {displayStatus()}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.wrapperTransaction}>
          <div className={styles.transactionDetails}>
            <div className={styles.iconWrapper}>
              <img
                className={styles.icon}
                src={
                  (payment.amount < 0 || isWithdrawal(payment))
                    ? IconMinus
                    : IconPlus
                  }
                alt="icon arrow"
              />
            </div>
            <div>
              <div className={styles.paymentType}>
                <p>{TextHelpers.getPaymentProcessName(payment.payment_process)}</p>
              </div>
              <div className={styles.paymentInfo}>
                {displayStatus()}
                {[
                  PaymentStatusEnum.Canceled,
                  PaymentStatusEnum.ForApproval,
                  PaymentStatusEnum.Rejected,
                  PaymentStatusEnum.ForApproval,
                ].includes(payment.payment_status) && <span className={styles.point}>•</span>}
                <div className={styles.date}>
                  { `${parseDateTo(new Date(payment.create_date), ParseToType.displayFormat)}` }
                </div>
              </div>
            </div>
          </div>
          <div className={classNames(styles.paymentAmount,
            { [styles.paymentAmountRejected]: payment.payment_status
              === PaymentStatusEnum.Rejected })}
          >
            {formatTransaction(payment, 'amount')}
          </div>
        </div>
      )}
    </>
  );
};

export default TransactionItem;
